module.exports = __webpack_public_path__ + "img/25_42.5885c39f.png";